import { combineReducers } from 'redux';
import list from 'groups/reducers/groups_list_reducers';
import form from 'groups/reducers/groups_form_reducers';

export const groupsReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/reducers/index.js